export const MAX_HISTORY = 20;

export const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Zen AI",
  "url": "https://zenai.app",
  "description": "AI meditation, mindfulness app, zen artificial intelligence, digital wellness, meditation assistant, spiritual guidance, AI wellness coach",
  "inLanguage": ["en", "fr", "it"]
};

export const labels = {
    en: {
      submit: 'Submit',
      changeLanguage: 'EN',
      messageHistory: 'Message History',
      mindfulInsight: 'Mindful reflection',
      generatingWisdom: 'Generating wisdom...',
      metaDescription: 'Experience mindfulness and AI-powered meditation with ZenAI.',
      metaTitle: 'ZenAI - AI-Powered Mindfulness & Meditation Assistant',
      signIn: 'Sign In',
      signOut: 'Sign Out'
    },
    fr: {
      submit: 'Soumettre',
      changeLanguage: 'FR',
      messageHistory: 'Historique des messages',
      mindfulInsight: 'Réflexion consciente',
      generatingWisdom: 'Génération de sagesse...',
      metaDescription: 'Découvrez la pleine conscience et la méditation assistée par IA avec ZenAI.',
      metaTitle: 'ZenAI - Assistant de Méditation et Pleine Conscience par IA',
      signIn: 'Connexion',
      signOut: 'Déconnexion'
    },
    it: {
      submit: 'Invia',
      changeLanguage: 'IT',
      messageHistory: 'Cronologia dei messaggi',
      mindfulInsight: 'Riflessione consapevole',
      generatingWisdom: 'Generazione saggezza...',
      metaDescription: 'Sperimenta la mindfulness e la meditazione guidata dall\'IA con ZenAI.',
      metaTitle: 'ZenAI - Assistente di Meditazione e Mindfulness con IA',
      signIn: 'Accedi',
      signOut: 'Esci'
    }
} as const;